import { z } from 'zod';

export const getImpactAnswersDtoSchema_Equipment = z.array(
  z.object({
    id: z.number(),
    userId: z.string(),
    projectId: z.number(),
    sector: z.string(),
    rentedEquipmentType: z.string(),
    rentalDays: z.number(),
    quantity: z.number(),
    isExternal: z.boolean(),
    label: z.string().nullable(),
    source: z.string().nullable(),
    score: z.number().optional(),
    tags: z
      .object({
        values: z
          .array(z.object({ id: z.number(), name: z.string() }))
          .optional(),
      })
      .optional(),
  }),
);

export type QuestionEquipmentDto = {
  id: number;
  userId: string;
  projectId: number;
  sector: string;
  rentedEquipmentType: string;
  rentalDays: number;
  quantity: number;
  isExternal: boolean;
  label: string | null;
  source?: string | null;
  score?: number;
  tags?: { values?: Array<{ id: number; name: string }> };
};
